module.exports = new Promise(resolve => {
      const src = window.AppConfig.INTEGRATIONS_UI_URL + "/remoteEntry.js"
      const script = document.createElement('script')
      script.src = src
       
       script.onload = () => {
        const proxy = {
          get: (request) => window.codat_integrations_ui.get(request),
          init: (arg) => {
            try {
              return window.codat_integrations_ui.init(arg)
            } catch(e) {
              console.error(e)
            }
          }
        }
        resolve(proxy)
      }
      script.onerror = () => {
        console.error("Failed to load " + src)
        resolve()
      }
      document.head.appendChild(script);
    });